import { AxiosPromise } from 'axios';

import { ITrainingStore } from '~/models/TrainingStore';
import { ITrainingStoreData } from '~/pages/I.LAB/Training-Store/EditTrainingStoreForm';

import api from './api';

const TrainingStoreService = {
  getAllTrainingStores(): AxiosPromise<ITrainingStore[]> {
    return api.get('training-stores/list/admin');
  },

  getTrainingStoreById(id: string): AxiosPromise<ITrainingStore> {
    return api.get(`training-stores/${id}`);
  },

  getFilterTrainingStores(
    segment: string,
    searchFilter?: string,
  ): AxiosPromise<ITrainingStore[]> {
    return searchFilter === ''
      ? api.get(`training-stores/list/admin?segment=${segment}`)
      : api.get(
          `training-stores/list/admin?segment=${segment}&description=${searchFilter}`,
        );
  },

  updateTrainingStores(
    data: ITrainingStoreData,
    trainingStoreId: string,
  ): AxiosPromise<ITrainingStore[]> {
    return api.put(`training-stores/${trainingStoreId}`, data);
  },

  deleteTrainingStores(
    trainingStoreId: string,
  ): AxiosPromise<ITrainingStore[]> {
    return api.delete(`training-stores/${trainingStoreId}`);
  },

  addTrainingStores(data: ITrainingStoreData): AxiosPromise<ITrainingStore[]> {
    return api.post(`training-stores`, data);
  },
};

export default TrainingStoreService;
